import {useQuery} from 'react-query';
import getInputGroupList from '.';

export const useGetInputGroupList = () => {
  const {data, isLoading} = useQuery('input-group-list', getInputGroupList);

  return {inputGroupList: data, isLoading};
};
